var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoadIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 20C12.55 20 13 19.55 13 19V17C13 16.45 12.55 16 12 16C11.45 16 11 16.45 11 17V19C11 19.55 11.45 20 12 20Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 14C12.55 14 13 13.55 13 13V11C13 10.45 12.55 10 12 10C11.45 10 11 10.45 11 11V13C11 13.55 11.45 14 12 14Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 8C12.55 8 13 7.55 13 7V5C13 4.45 12.55 4 12 4C11.45 4 11 4.45 11 5V7C11 7.55 11.45 8 12 8Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M5 20C5.55 20 6 19.55 6 19V5C6 4.45 5.55 4 5 4C4.45 4 4 4.45 4 5V19C4 19.55 4.45 20 5 20Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M19 4C18.45 4 18 4.45 18 5V19C18 19.55 18.45 20 19 20C19.55 20 20 19.55 20 19V5C20 4.45 19.55 4 19 4Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoadIcon);
export { ForwardRef as ReactComponent };